import { tbwSectionDataActionTypes } from '../constants/tbw-action-types';

interface tasksType {
    taskKey: string;
    taskDescription: string;
    taskCoachmark: object;
    successConditions: Array<any>;
    taskType: string;
    sectionKey: string;
    taskRenditions: Array<RenditionType>;
}

interface RenditionType {
    url: string;
    type: string;
}

interface taskImages {
    imageId: number;
    taskImageUrl: string;
    taskKey: string;
}

interface sectionsType {
    sectionTitle: string;
    sectionDescription: string;
    sectionKey: string;
    sectionVideoUrl?: string;
    taskListKeys: Array<string>;
    successMessage: string;
    tasksImageList: Array<taskImages>;
}

interface intialState {
    sectionData: Array<sectionsType>;
    taskData: Array<tasksType>;
    docId: string;
    stepCounter: number;
    taskCounter: number;
}
const intialState: intialState = {
    sectionData: [
        /*{
      sectionKey: "Some-message-section-1",
      sectionTitle: "",
      sectionDescription: "",
      sectionVideoUrl: "",
      successMessage: "",
      taskListKeys: [],
      tasksImageList: [],
    },*/
    ],
    taskData: [],
    docId: 'Some-message',
    stepCounter: 1,
    taskCounter: 1,
};

const createNewEmptySection = (sectionData, { docId, locId }, stepCounter) => {
    const sectionDataNew = JSON.parse(JSON.stringify(sectionData));
    const sectionDataCount = sectionDataNew.length;
    let newSection = {};
    newSection['sectionKey'] = `${docId}-section-${stepCounter}`;
    newSection['sectionTitle'] = '';
    newSection['sectionDescription'] = '';
    newSection['sectionVideoUrl'] = '';
    newSection['successMessage'] = '';
    newSection['taskListKeys'] = [];
    newSection['tasksImageList'] = [];
    sectionDataNew.splice(locId, 0, newSection);
    return {
        newSectionData: [...sectionDataNew],
        newStepCounter: stepCounter + 1,
    };
};

const deleteExistingSection = (sectionData, taskData, sectionKey, docId, stepCounter) => {
    const sectionDataNew = JSON.parse(JSON.stringify(sectionData));
    const taskDataNew = JSON.parse(JSON.stringify(taskData));
    let newStepCounter = stepCounter;
    var filteredTasks = taskDataNew.filter((el) => {
        return el.sectionKey != sectionKey;
    });
    var filteredSections = sectionDataNew.filter((el) => {
        return el.sectionKey != sectionKey;
    });
    if (filteredSections.length === 0) {
        filteredSections = [...createNewEmptySection(filteredSections, { docId, locId: 1 }, 2).newSectionData];
        newStepCounter = 1;
    }
    return { filteredTasks, filteredSections, newStepCounter };
};

const updateSection = (sectionData, payload) => {
    const sectionDataNew = JSON.parse(JSON.stringify(sectionData));
    for (let i = 0; i < sectionDataNew.length; i++) {
        if (sectionDataNew[i].sectionKey === payload.sectionKey) {
            let updatedSection: any = {};
            updatedSection = { ...JSON.parse(JSON.stringify(payload)) };
            sectionDataNew[i] = updatedSection;
        }
    }
    return sectionDataNew;
};
const moveSectionUp = (sectionData, sectionKey) => {
    const sectionDataNew = JSON.parse(JSON.stringify(sectionData));
    const fromIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    if (fromIndex !== 0) {
        const toIndex = fromIndex - 1;
        // console.log('Step indexes::::', fromIndex, toIndex);
        let fromTask = sectionDataNew[fromIndex];
        sectionDataNew[fromIndex] = sectionDataNew[toIndex];
        sectionDataNew[toIndex] = fromTask;
    }
    return sectionDataNew;
};
const moveSectionDown = (sectionData, sectionKey) => {
    const sectionDataNew = JSON.parse(JSON.stringify(sectionData));
    const fromIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    if (fromIndex !== sectionData.length - 1) {
        const toIndex = fromIndex + 1;
        // console.log('Step indexes::::', fromIndex, toIndex);
        let fromTask = sectionDataNew[fromIndex];
        sectionDataNew[fromIndex] = sectionDataNew[toIndex];
        sectionDataNew[toIndex] = fromTask;
    }
    return sectionDataNew;
};
const injectNewEmptytask = ({ sectionKey, taskType }, sectionData, taskData, taskCounter) => {
    let sectionDataNew: any = JSON.parse(JSON.stringify(sectionData));
    let taskDataNew: any = JSON.parse(JSON.stringify(taskData));
    let newTask = {};
    const newTaskKey = `${sectionKey}-${taskType}-${taskCounter}`;
    newTask['taskKey'] = newTaskKey;
    newTask['taskDescription'] = '';
    newTask['taskCoachmark'] = {};
    newTask['successConditions'] = [];
    newTask['taskType'] = taskType;
    newTask['sectionKey'] = sectionKey;
    newTask['taskRenditions'] = [];
    taskDataNew = [...taskDataNew, newTask];

    const fromIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    let obj: any = sectionDataNew[fromIndex];
    obj['taskListKeys'] = [...obj['taskListKeys'], newTaskKey];

    sectionDataNew[fromIndex] = obj;
    return { sectionDataNew, taskDataNew, taskCounter: taskCounter + 1 };
};

const deleteExistingTask = ({ sectionKey, taskKey }, sectionData, taskData) => {
    let sectionDataNew: any = JSON.parse(JSON.stringify(sectionData));
    const sectionIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    let sectionObj: any = sectionDataNew[sectionIndex];
    const sectionTaskKeys = [...sectionObj.taskListKeys];
    const newSectionTaskKeys = sectionTaskKeys.filter((el) => el !== taskKey);
    sectionObj['taskListKeys'] = [...newSectionTaskKeys];
    sectionDataNew[sectionIndex] = sectionObj;

    let taskDataNew: any = JSON.parse(JSON.stringify(taskData));
    let taskDataUpdated: any = taskDataNew.filter((obj) => obj.taskKey !== taskKey);
    return { sectionDataNew, taskDataUpdated };
};

const moveTaskUp = ({ sectionKey, taskKey }, sectionData) => {
    let sectionDataNew: any = JSON.parse(JSON.stringify(sectionData));
    const sectionIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    let sectionObj: any = sectionDataNew[sectionIndex];
    const sectionTaskKeys = [...sectionObj.taskListKeys];

    const sectionTaskIndex = sectionTaskKeys.findIndex((obj) => obj === taskKey);
    if (sectionTaskIndex !== 0) {
        let temp = sectionTaskKeys[sectionTaskIndex - 1];
        sectionTaskKeys[sectionTaskIndex - 1] = sectionTaskKeys[sectionTaskIndex];
        sectionTaskKeys[sectionTaskIndex] = temp;
    }
    sectionObj['taskListKeys'] = [...sectionTaskKeys];
    sectionDataNew[sectionIndex] = sectionObj;

    return sectionDataNew;
};
const moveTaskDown = ({ sectionKey, taskKey }, sectionData) => {
    let sectionDataNew: any = JSON.parse(JSON.stringify(sectionData));
    const sectionIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    let sectionObj: any = sectionDataNew[sectionIndex];
    const sectionTaskKeys = [...sectionObj.taskListKeys];

    const sectionTaskIndex = sectionTaskKeys.findIndex((obj) => obj === taskKey);
    if (sectionTaskIndex + 1 !== sectionTaskKeys.length) {
        let temp = sectionTaskKeys[sectionTaskIndex + 1];
        sectionTaskKeys[sectionTaskIndex + 1] = sectionTaskKeys[sectionTaskIndex];
        sectionTaskKeys[sectionTaskIndex] = temp;
    }
    sectionObj['taskListKeys'] = [...sectionTaskKeys];
    sectionDataNew[sectionIndex] = sectionObj;

    return sectionDataNew;
};
const updateTask = ({ taskKey, payload }, taskData) => {
    const taskDataNew = JSON.parse(JSON.stringify(taskData));

    const taskIndex = taskDataNew.findIndex((obj) => obj.taskKey === taskKey);
    taskDataNew[taskIndex] = JSON.parse(JSON.stringify(payload));
    return taskDataNew;
};

const updateTaskImageList = ({ sectionKey, list }, sectionData) => {
    const sectionDataNew = JSON.parse(JSON.stringify(sectionData));

    const fromIndex = sectionDataNew.findIndex((obj) => obj.sectionKey === sectionKey);
    if (fromIndex !== -1) {
        let updatedSection: any = sectionDataNew[fromIndex];
        updatedSection['tasksImageList'] = [...list];
        sectionDataNew[fromIndex] = updatedSection;
    }
    return sectionDataNew;
};

const updateTaskSuccessCondition = ({ taskKey, payload }, taskData) => {
    const taskDataNew = JSON.parse(JSON.stringify(taskData));

    const taskIndex = taskDataNew.findIndex((obj) => obj.taskKey === taskKey);
    taskDataNew[taskIndex]['successConditions'] = [JSON.parse(JSON.stringify(payload))];
    return taskDataNew;
};

export const tbwSectionDataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case tbwSectionDataActionTypes.INJECT_NEW_EMPTY_SECTION: {
            const newPayload = createNewEmptySection(state.sectionData, payload, state.stepCounter);
            return {
                ...state,
                sectionData: [...newPayload.newSectionData],
                stepCounter: newPayload.newStepCounter,
                docId: payload?.docId,
            };
        }
        case tbwSectionDataActionTypes.UPDATE_EXISTING_SECTION: {
            const updatedSectionData = updateSection(state.sectionData, payload);
            return { ...state, sectionData: [...updatedSectionData] };
        }
        case tbwSectionDataActionTypes.DELETE_EXISTING_SECTION: {
            const newData = deleteExistingSection(
                state.sectionData,
                state.taskData,
                payload,
                state.docId,
                state.stepCounter,
            );
            return {
                ...state,
                sectionData: [...newData.filteredSections],
                taskData: [...newData.filteredTasks],
                stepCounter: newData.newStepCounter,
            };
        }
        case tbwSectionDataActionTypes.MOVE_SECTION_UP: {
            const updatedSectionData = moveSectionUp(state.sectionData, payload);
            return { ...state, sectionData: [...updatedSectionData] };
        }
        case tbwSectionDataActionTypes.MOVE_SECTION_DOWN: {
            const updatedSectionData = moveSectionDown(state.sectionData, payload);
            return { ...state, sectionData: [...updatedSectionData] };
        }
        case tbwSectionDataActionTypes.INJECT_NEW_EMPTY_TASK: {
            const newPayload: any = injectNewEmptytask(payload, state.sectionData, state.taskData, state.taskCounter);
            return {
                ...state,
                sectionData: [...newPayload['sectionDataNew']],
                taskData: [...newPayload['taskDataNew']],
                taskCounter: newPayload.taskCounter,
            };
        }
        case tbwSectionDataActionTypes.DELETE_EXISTING_TASK: {
            const newPayload: any = deleteExistingTask(payload, state.sectionData, state.taskData);
            return {
                ...state,
                sectionData: [...newPayload['sectionDataNew']],
                taskData: [...newPayload['taskDataUpdated']],
            };
        }
        case tbwSectionDataActionTypes.MOVE_TASK_UP: {
            const newPayload: any = moveTaskUp(payload, state.sectionData);
            return {
                ...state,
                sectionData: [...newPayload],
            };
        }
        case tbwSectionDataActionTypes.MOVE_TASK_DOWN: {
            const newPayload: any = moveTaskDown(payload, state.sectionData);
            return {
                ...state,
                sectionData: [...newPayload],
            };
        }
        case tbwSectionDataActionTypes.UPDATE_EXISTING_TASK: {
            const newPayload: any = updateTask(payload, state.taskData);
            return {
                ...state,
                taskData: [...newPayload],
            };
        }

        case tbwSectionDataActionTypes.UPDATE_TASK_IMAGES: {
            const updatedSectionData = updateTaskImageList(payload, state.sectionData);
            return { ...state, sectionData: [...updatedSectionData] };
        }
        //updateTaskSuccessCondition

        case tbwSectionDataActionTypes.UPDATE_TASK_SUCCESSCONDITION: {
            const newPayload: any = updateTaskSuccessCondition(payload, state.taskData);
            return { ...state, taskData: [...newPayload] };
        }
        case tbwSectionDataActionTypes.UPDATE_TOTAL_SECTION_DATA: {
            return {
                ...state,
                taskData: [...payload.taskData],
                sectionData: [...payload.sectionData],
                docId: payload.docId,
                stepCounter: payload.stepCounter + 1,
                taskCounter: payload.taskCounter + 1,
            };
        }
        case tbwSectionDataActionTypes.RESET_SECTION_DATA: {
            return {
                ...intialState,
            };
        }
        default:
            return state;
    }
};
